if (!customElements.get("swiper-slider")) {
  class SwiperSlider extends HTMLElement {
    constructor() {
      super();
      this.slideContainer = this.querySelector("[data-swiper]:not([data-swiper-thumbs])");
      this.slides = this.querySelectorAll("[data-swiper-slide]");
      this.sliderOptions = this.applyDefaultOptions(this.getSliderOptions());
      this.count = 0;
      this.activeIndex = 0;
      this.initialized = false;
      this.boundInitializeSwiper = this.initializeSwiper.bind(this);
      if (this.dataset.swiperThumbs) {
        this.thumbnails = this.querySelector('[data-swiper-thumbs]');
      }
      if (this.dataset.customEvent) {
        this.attachCustomListeners(this.dataset.customEvent);
      }
      if (this.slideContainer && this.slides.length > 0) {
        document.addEventListener(
          "DOMContentLoaded",
          this.initializeSwiper.bind(this)
        );
        document.addEventListener(
          "shopify:section:load",
          this.initializeSwiper.bind(this)
        );
        document.addEventListener(
          "oddit-pagination-complete",
          this.initializeSwiper.bind(this)
        );
        window.addEventListener("resize", this.handleResize.bind(this));
        this.addEventListener("go-to-slide", this.goToSlide.bind(this));
      } else {
        console.warn("SwiperSlider - Slider or Slides Not Found");
      }
    }
    attachCustomListeners(customEvent) {
      switch (customEvent) {
        case "swiper_event":
          document.addEventListener("swiper_event", this.updateSlides.bind(this));
          break;
        case "reinitialize":
          this.addEventListener('reinitialize-swiper', this.boundInitializeSwiper);
          break;
      }
    }
    updateSlides(event) {
    }
    applyDefaultOptions(options) {
      if (options.loop === undefined) {
        options.loop = true;
      }
      options.speed = 400;
      return options;
    }

    getSliderOptions() {
      try {
        return JSON.parse(this.dataset.swiperOptions);
      } catch (err) {
        console.log(err);
        return {};
      }
    }

    initializeSwiper() {
      if (window.Swiper && !this.initialized) {
        this.initialized = true;
        if(this.thumbnails) {
          this.setThumbnails()
        }
        this.slider = new Swiper(this.slideContainer, this.sliderOptions);
        this.initializeSwiperListeners()
        this.initializeSliderEventListeners();
      } else if (!window.Swiper) {
        console.warn("SwiperSlider - Swiper.js not found");
      }
    }

    handleResize(e) {
      if (this.slider) {
        setTimeout(() => {
          this.slider.updateSize();
        }, 300);
      }
    }

    goToSlide(evt){
      let index = evt.detail.index;
      if(!index && evt.detail.position) {
        const elm = this.querySelector("[data-position='" + evt.detail.position + "']");
        index = [...elm.parentNode.children].indexOf(elm);
      }
      if(index != 0 && !index) return;
      this.slider.slideTo(index);
    }

setThumbnails() {
      const thumbsSlideContainer = this.thumbnails;
      const thumbOptions = JSON.parse(this.thumbnails.dataset.swiperOptions);
      const thumbnailsSlider = new Swiper(thumbsSlideContainer, thumbOptions);
      this.sliderOptions.thumbs = { swiper: thumbnailsSlider };
      this.sliderOptions.on = {
        slideChange: function () {
          let activeIndex = this.activeIndex;
          document.dispatchEvent(
            new CustomEvent("thumbnail-changed", {
              detail: {
                slide: this.slides[this.activeIndex],
              },
            })
          );
          setTimeout(() => {
            
          this.thumbs.swiper.slideTo(activeIndex > 0 ? activeIndex : 0);
          }, 100)
        },
      };
    }
    initializeSwiperListeners() {
      if (this.classList.contains('product-gallery')) {
        this.slider.on('slideChange', () => {
          window.VWO = window.VWO || [];
          window.VWO.event = window.VWO.event || function () {window.VWO.push(["event"].concat([].slice.call(arguments)))};
          window.VWO.event("pdpCarouselClick");
        });
      }

      if (this.dataset.hasOwnProperty('cylindoSwiperMobile')) {
        this.slides.forEach((slide, slideIndex) => slide.addEventListener('click', () => {
          document.dispatchEvent(new CustomEvent("td:custom-thumbnail-change", {detail: {newIndex: slideIndex + 1}}))
        }))
      }

      if (this.dataset.hasOwnProperty('productLifestyleSlider')) {
        this.slides.forEach((slide, slideIndex) => {
          slide.addEventListener('click', () => {
            document.dispatchEvent(new CustomEvent('td:gallery-changed', {detail: {slide: slide}}));
          })
        })
      }
      
      if (this.dataset.hasOwnProperty('productGalleryV3')) {
        document.addEventListener('td:gallery-changed', this.handleGalleryChange.bind(this))
      }
    }

    initializeSliderEventListeners() {
      if (this.dataset.hasOwnProperty('productImagesSlider')) {
        document.addEventListener('appBasedImageChange', this.handleVariantSelected.bind(this))
      }
      if (this.classList.contains('product-gallery')) {
        document.addEventListener('td:display-avaatar', this.handleAvaatarDisplay.bind(this))
        document.addEventListener('td:display-cylindo', this.handleCylindoDisplay.bind(this))
        document.addEventListener('td:custom-thumbnail-change', this.handleCustomThumbnail.bind(this))
      }      
    }
    handleVariantSelected(e) {
      const variant = e.detail.variant
      if (variant && variant.featured_image && variant.featured_image.src) {
        this.maybeSlideToImage(variant.featured_image.src)
       
      }
    }
    handleGalleryChange({detail}) {
      console.log("Handling gallery change", detail)
      const matchingSlideIndex = [...this.slides].findIndex((slide) => slide.dataset.mediaId == detail.slide.dataset.mediaId)
      if (matchingSlideIndex > -1) {
        this.slider.slideTo(matchingSlideIndex)
      }
    }
    maybeSlideToImage(url) {
      const cleanedUrl = this.handleFileName(url)
      const matchingSlideIndex = [...this.slides].findIndex((slide) => {
        if (slide.classList.contains('swiper-slide-duplicate')) return
        const image = slide.querySelector('img')
        if (image) {
          const fileName = this.handleFileName(image.src)
          return fileName == cleanedUrl
        }
        return false
      })
      if (matchingSlideIndex >= 0) {
        // NOTE looks like swiper is 1 based indexing --> NOT ANYMORE
        this.slider.slideTo(matchingSlideIndex)
        
      }
    }
    handleAvaatarDisplay() {
      // NOTE wasn't sure a better way around this -> slide to second slide after first render
      if (this.count < 2) {
        this.count = this.count + 1;
        this.slider.slideTo(0);
        return
      } else {this.slider.slideTo(1);}
    }
    handleCylindoDisplay() {
      this.slider.slideTo(0)
    }
    handleCustomThumbnail({detail}) {
      this.slider.slideTo(detail.newIndex)
    }
    handleFileName(url) {
      // console.log(url)
      let filename = url.substring(url.lastIndexOf("/") + 1);

      if (filename.includes('?')) {
        // "your-image_150x.jpg?v=110101010" => "your-image_150x.jpg"
        filename = filename.substr(0, filename.indexOf("?"));
      }
      
      // "your-image_150x.jpg" => "your-image.jpg"
      return filename.replace(/_\d+x\./, ".");
    }
  }
  customElements.define("swiper-slider", SwiperSlider);
  
}
